import { CircleHitbox, GroupHitbox } from "./hitbox";
import shapes from "./rockShapes49.json";
import { Vec, type Vector } from "./vector";

export function isPaintedRock(id: string): id is keyof typeof shapes {
    return id === "rock" || id === "river_rock";
}

/** Same object-ID variant selection and byte-quantized rotation as the client. */
export function rockHitbox(kind: string, id: number, position: Vector, scale: number, rotation: number): GroupHitbox<CircleHitbox[]> | undefined {
    if (!isPaintedRock(kind)) return undefined;
    const variants = shapes[kind];
    const angle = (Math.round((rotation / (2 * Math.PI) + .5) * 255) / 255 - .5) * 2 * Math.PI;
    const c = Math.cos(angle), s = Math.sin(angle);
    return new GroupHitbox(...variants[id % variants.length].map(([x, y, r]) => new CircleHitbox(
        r * scale,
        Vec(position.x + (x * c - y * s) * scale, position.y + (x * s + y * c) * scale)
    )));
}
